import React, { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { colors, spacing } from '../../constants/theme';
import { Text, TextInput } from '../../core-ui';
import { IdCardDataInput } from '../../../../generated/globalTypes';

import { Collapsible } from './Collapsible';

type Props = {
  data?: IdCardDataInput | null;
  disabled?: boolean;
  onChangeData?: (key: keyof IdCardDataInput, value: string) => void;
};

export default function AdditionalDataCollapsible({
  data,
  disabled = false,
  onChangeData,
}: Props) {
  const [isOpened, setIsOpened] = useState(false);

  const collapsibleTitle = useCallback(
    () => (
      <View
        style={[styles.collapsibleContainer, isOpened && styles.noBottomBorder]}
      >
        <Text bold>Additional Info KTP</Text>
        {isOpened ? (
          <ExpandLessIcon color="inherit" fontSize="default" />
        ) : (
          <ExpandMoreIcon color="inherit" fontSize="default" />
        )}
      </View>
    ),
    [isOpened],
  );

  return (
    <Collapsible
      onPressClosing={() => setIsOpened(false)}
      onPressOpening={() => setIsOpened(true)}
      title={collapsibleTitle()}
      titleOpened={collapsibleTitle()}
      contentStyle={[styles.collapsibleContent, isOpened && styles.noTopBorder]}
    >
      <>
        <TextInput
          containerStyle={styles.lBottomSpacing}
          value={data?.address || ''}
          onChangeText={(text) => onChangeData?.('address', text)}
          label="Alamat KTP"
          placeholder="Data Alamat serta Nomor RT ＆ RW"
          disabled={disabled}
        />
        <TextInput
          containerStyle={styles.lBottomSpacing}
          value={data?.urbanVillage || ''}
          onChangeText={(text) => onChangeData?.('urbanVillage', text)}
          label="Kelurahan / Desa"
          placeholder="Data Kelurahan"
          disabled={disabled}
        />
        <TextInput
          containerStyle={styles.lBottomSpacing}
          value={data?.district || ''}
          onChangeText={(text) => onChangeData?.('district', text)}
          label="Kecamatan"
          placeholder="Data Kecamatan"
          disabled={disabled}
        />
        <TextInput
          containerStyle={styles.lBottomSpacing}
          value={data?.city || ''}
          onChangeText={(text) => onChangeData?.('city', text)}
          label="Kota / Kabupaten"
          placeholder="Data Kota / Kabupaten (Dibawah Foto KTP)"
          disabled={disabled}
        />
      </>
    </Collapsible>
  );
}

const styles = StyleSheet.create({
  lBottomSpacing: {
    marginBottom: spacing.l,
  },
  noBottomBorder: {
    borderBottomWidth: 0,
    borderBottomStartRadius: 0,
    borderBottomEndRadius: 0,
  },
  noTopBorder: {
    borderTopWidth: 0,
    borderTopStartRadius: 0,
    borderTopEndRadius: 0,
  },
  collapsibleContainer: {
    padding: spacing.m,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.border.primary,
    borderRadius: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  collapsibleContent: {
    paddingTop: spacing.s,
    paddingHorizontal: spacing.m,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.border.primary,
    borderRadius: 8,
    backgroundColor: colors.background.white,
  },
});
